// src/Pages/Onboarding/ZidOnboarding/ProgressBar.jsx
import React from 'react';

export default function ProgressBar({ currentStep, totalSteps }) {
  const percentage = (currentStep / totalSteps) * 100; // calculate fill percentage

  return (
    <div className="w-full bg-gray-200 rounded-full h-2.5 overflow-hidden">
      <div
        className="h-full bg-purple-600 transition-all duration-500"
        style={{ width: `${percentage}%`, backgroundColor: '#7F28F8' }}
      />
    </div>
  );
}
